const NODE_ENV = process?.env?.NODE_ENV;
const config = JSON.parse(process?.env?.VUE_APP_CONFIG);

config.env = process?.env?.VUE_APP_ENV;
config.version = '1.1.0';
if (NODE_ENV === 'development') {
  config.env = 'test';
}

export default config;
